import { getSchemaAttr, hasSchemaAttr, nodeToDOM } from '@common/util/schema';
import { NodeSpec } from 'prosemirror-model';
import { SchemaPlugin } from '../../prosemirror/model/schema-plugin';

export class ListSchemaPlugin extends SchemaPlugin {
  nodes = {
    bullet_list: {
      group: 'block',
      content: 'list_item+',
      childLinkBucket: 'unordered_list',
      list: true,
      parseDOM: [{
        tag: 'ul'
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'ul',
      specContent: 'list_item'
    },

    ordered_list: {
      group: 'block',
      content: 'list_item+',
      childLinkBucket: 'ordered_list',
      list: true,
      attrs: {
        start: {
          default: 1,
          toFlareXML(value: any): string {
            return value !== 1 ? value : null;
          }
        }
      },
      parseDOM: [{
        tag: 'ol',
        getAttrs(dom: HTMLElement) {
          return {
            start: hasSchemaAttr(dom, 'start') ? +getSchemaAttr(dom, 'start') : 1
          };
        }
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'ol',
      specContent: 'list_item'
    },

    menu: {
      group: 'block',
      content: 'inline*',
      parseDOM: [{
        tag: 'menu'
      }],
      toDOM(node) { return nodeToDOM(node); }
    },

    // Deprecated in browsers
    dir: {
      group: 'block',
      content: 'list_item+',
      parseDOM: [{
        tag: 'dir'
      }],
      toDOM(node) { return nodeToDOM(node); },
      specContent: 'list_item'
    },

    // Obsolete in browsers
    menuitem: {
      group: 'inline',
      content: 'inline*',
      inline: true,
      definingForContent: true,
      parseDOM: [{
        tag: 'menuitem',
        preserveWhitespace: true
      }],
      toDOM(node) { return nodeToDOM(node); },
      isVoid: true,
      atom: true,
      isTagNameBox: true
    },

    list_item: {
      content: 'block+',
      definingForContent: true, // Not definingForContext so that list items can be pasted over
      fillIfContentDeleted: 'mcCentralContainer',
      listItem: true,
      parseDOM: [{
        tag: 'li'
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'li',
      specContext: 'bullet_list'
    }
  } satisfies Record<string, NodeSpec>;
}
